export const RACE_CHOOSE = 'character.RACE_CHOOSE';
export const RACE_CHOOSE_POST_ACTION = 'character.RACE_CHOOSE_POST_ACTION';
export const RACE_SET = 'character.RACE_SET';
export const RACE_SET_COMMIT = 'character.RACE_SET_COMMIT';
export const RACE_UNSET = 'character.RACE_UNSET';
